import { IDisburseAllDisbursementData } from 'types/order/escrow/IDisburseAllDisbursementData';
import { eDisbursementType } from 'types/order/escrow/eDisbursementType';

export const filterDisbursementsByType = (
  disbursements: IDisburseAllDisbursementData[],
  excludedDisbursements: string[],
  onToggle: (x: string) => void
): {
  [key in Exclude<eDisbursementType, eDisbursementType.Unknown>]: IDisburseAllDisbursementData[];
} =>
  disbursements.reduce(
    (filteredDisbursements, disbursement) => {
      const type = disbursement.disbursement.type;
      filteredDisbursements[type].push({
        ...disbursement,
        enabled: !excludedDisbursements.includes(disbursement.disbursement.id),
        onToggle: () => onToggle(disbursement.disbursement.id),
      });
      return filteredDisbursements;
    },
    {
      [eDisbursementType.ACH]: [],
      [eDisbursementType.Check]: [],
      [eDisbursementType.Wire]: [],
      [eDisbursementType.InternalTransfer]: [],
    } as { [key in Exclude<eDisbursementType, eDisbursementType.Unknown>]: IDisburseAllDisbursementData[] }
  );
